// src/hooks/useGridFiltersFromURL.ts
import { useLocation } from 'react-router-dom';
import { GridReadyEvent } from 'ag-grid-community';
import { RefObject } from 'react';
import { AgGridReact } from 'ag-grid-react';

export const useGridFiltersFromURL = (ref: any) => {
  const location = useLocation();

  const handleGridReady = (params: GridReadyEvent) => {
    if (ref?.current?.api) {
      const gridApi = ref.current.api;
      const searchParams = new URLSearchParams(location.search);
      const filterModel: any = {};

      searchParams.forEach((value: any, key) => {
        const cleaned = value.replace(/^\[|\]$/g, ''); // removes [ and ]
        const [filter="", type = 'contains', filterType = 'text'] = cleaned.split(',');
        filterModel[key] = { filterType, type, filter };
      });

      gridApi.setFilterModel(filterModel);
      gridApi.onFilterChanged();
    }
  };

  return handleGridReady;
};
